import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-[72px]"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}